import { Entity } from '@api/api/entity-schema';
import { formatPriceDisplay } from '@terminal/components/price-display-view/helpers/price-display-helpers';
import { usePreliminaryPrice } from '@terminal/react-query-hooks/prices/usePreliminaryPrice';
import { useSnakeMeta } from '@terminal/react-query-hooks/snakes/useSnake';
import { getEntityPriceVenue } from '@terminal/services/price/price-service';
import { useTranslation } from 'react-i18next';

import { ReactionMetric } from './ReactionMetric';

export interface CompanyOneDayReactionProps {
  entity: Entity;
}

export const CompanyOneDayReaction = ({
  entity,
}: CompanyOneDayReactionProps) => {
  const { t } = useTranslation(['analyze']);
  const { data: snakeMeta, isLoading } = useSnakeMeta(entity.default_snake);
  const { data: preliminaryPrice } = usePreliminaryPrice(
    entity.subscribable_ticker ?? '',
    getEntityPriceVenue(entity)
  );

  const priceChange =
    snakeMeta &&
    formatPriceDisplay({
      exchange: entity.exchange.code,
      meta: snakeMeta,
      preliminaryPrice: preliminaryPrice?.data,
      isHovered: false,
      t,
    }).primary.priceChange;

  if (isLoading || !priceChange || !priceChange?.proportionChange) {
    return null;
  }

  return (
    <ReactionMetric
      formattedValue={priceChange.proportionChange}
      i18nKey="widget:themeOverview.pulse.drawer.oneDayReaction"
      value={Number.parseFloat(priceChange.proportionChange)}
    />
  );
};
